<p *ngIf="!plans?.length">
  {{ 'organizer.manage_timeslot.actions.edit_offers.to_define' | translate }}
</p>

<ul>
  <li
    *ngFor="let plan of plans; let isFirst = first"
    class="flex items-center"
    [class.mt-2]="!isFirst"
  >
    <ng-container *ngIf="isLightMode && plans?.length === 1">
      {{ plan.price | displayPrice: plan.currency }}
    </ng-container>

    <ng-container *ngIf="isFullMode || plans?.length > 1">
      <span class="mr-2 truncate">
        {{ plan.name }}
        <ng-container *ngIf="plansMaximumCapacity">
          -
          {{
            'organizer.manage_timeslot.actions.edit_offers.max_capacity'
              | translate: { maxCapacity: plansMaximumCapacity }
          }}
        </ng-container>
      </span>

      <span class="flex-shrink-0 ml-auto">
        {{ plan.price | displayPrice: plan.currency }}
      </span>
    </ng-container>
  </li>
</ul>
